/**
 * Topografie (TOPO) — 23 families, 4 skills
 *
 * Skills: nederland (7), europa (8), wereld (7), interpretatie (1)
 *
 * Split from taxonomyRegistry.ts in R23.
 */

import type { FamilyDefinition } from '../types'

export const TOPO_FAMILIES: FamilyDefinition[] = [
  // 7.1 Skill: nederland (7 families)
  {
    familyId: 'TOPO-NL-PROV',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_provincies',
    tier: 1,
    levelCode: 'B6',
    description: 'Provincies Nederland',
  },
  {
    familyId: 'TOPO-NL-STEDEN',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_steden_nl',
    tier: 3,
    levelCode: 'M6',
    description: 'Grote steden & provinciehoofdsteden',
  },
  {
    familyId: 'TOPO-NL-STEDEN-REGIO',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_steden_regio_nl',
    tier: 5,
    levelCode: 'E6',
    description: 'Steden per provincie & regio',
  },
  {
    familyId: 'TOPO-NL-WATER',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_wateren',
    tier: 5,
    levelCode: 'E6',
    description: 'Wateren Nederland',
  },
  {
    familyId: 'TOPO-NL-LANDSCHAP',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_landschap_nl',
    tier: 7,
    levelCode: 'B7',
    description: 'Landschapstypen Nederland',
  },
  {
    familyId: 'TOPO-NL-BUURLANDEN',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_buurlanden',
    tier: 4,
    levelCode: 'M6+',
    description: 'Buurlanden Nederland',
  },
  {
    familyId: 'TOPO-NL-EILANDEN',
    module: 'Topo',
    skill: 'nederland',
    subSkill: 'topo_eilanden',
    tier: 7,
    levelCode: 'B7',
    description: 'Waddeneilanden',
  },
  // 7.2 Skill: europa (8 families)
  {
    familyId: 'TOPO-EU-LAND',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_landen_eu',
    tier: 7,
    levelCode: 'B7',
    description: 'Landen Europa',
  },
  {
    familyId: 'TOPO-EU-HOOFDST',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_hoofdsteden_eu',
    tier: 8,
    levelCode: 'B7+',
    description: 'Hoofdsteden Europa (kerndoel)',
  },
  {
    familyId: 'TOPO-EU-FYSISCH',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_fysisch',
    tier: 9,
    levelCode: 'M7',
    description: 'Fysische geografie Europa',
  },
  {
    familyId: 'TOPO-EU-GEBERGTE',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_gebergte_eu',
    tier: 11,
    levelCode: 'E7',
    description: 'Gebergten Europa',
  },
  {
    familyId: 'TOPO-EU-RIVIEREN',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_rivieren_eu',
    tier: 11,
    levelCode: 'E7',
    description: 'Grote rivieren Europa',
  },
  {
    familyId: 'TOPO-EU-ZEEEN',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_zeeen_eu',
    tier: 9,
    levelCode: 'M7',
    description: 'Zeeën en oceanen Europa',
  },
  {
    familyId: 'TOPO-EU-KLIMAAT',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_klimaat_eu',
    tier: 13,
    levelCode: 'B8',
    description: 'Klimaatzones Europa',
  },
  {
    familyId: 'TOPO-EU-BUURLANDEN',
    module: 'Topo',
    skill: 'europa',
    subSkill: 'topo_buurlanden_eu',
    tier: 9,
    levelCode: 'M7',
    description: 'Buurlanden van EU-landen (grenzen)',
  },
  // 7.3 Skill: wereld (7 families)
  {
    familyId: 'TOPO-WERELD-CONT',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_continenten',
    tier: 7,
    levelCode: 'B7',
    description: 'Continenten en oceanen',
  },
  {
    familyId: 'TOPO-WERELD-OCEANEN',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_oceanen_wereld',
    tier: 9,
    levelCode: 'M7',
    description: 'Oceanen en grote zeeën wereld',
  },
  {
    familyId: 'TOPO-WERELD-HOOFDST',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_hoofdsteden_wereld',
    tier: 11,
    levelCode: 'E7',
    description: 'Wereldhoofdsteden (kerndoel)',
  },
  {
    familyId: 'TOPO-WERELD-RIVIER',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_rivieren_wereld',
    tier: 11,
    levelCode: 'E7',
    description: 'Grote rivieren wereld (kerndoel)',
  },
  {
    familyId: 'TOPO-WERELD-GEBERGTE',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_gebergte_wereld',
    tier: 13,
    levelCode: 'B8',
    description: 'Wereldgebergten (kerndoel)',
  },
  {
    familyId: 'TOPO-WERELD-LANDEN',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_landen_wereld',
    tier: 13,
    levelCode: 'B8',
    description: 'Belangrijke landen wereld',
  },
  {
    familyId: 'TOPO-WERELD-KLIMAAT',
    module: 'Topo',
    skill: 'wereld',
    subSkill: 'topo_klimaat_wereld',
    tier: 15,
    levelCode: 'E8',
    description: 'Klimaatzones wereld',
  },
  // 7.4 Skill: interpretatie (1 family)
  {
    familyId: 'TOPO-KLIMAAT',
    module: 'Topo',
    skill: 'interpretatie',
    subSkill: 'klimaat_zones',
    tier: 15,
    levelCode: 'E8',
    description: 'Klimaatzones interpreteren',
  },
]
